<template>
    <Card :title="$t('labels.inventory')">
        <div class="card-body">
            <FormGroup :label="$t('labels.warehouse')">
                <AppAutoComplete
                    url="/management/warehouses"
                    option-key="id"
                    :model-value="warehouse?.id"
                    :selected-value="warehouse?.name"
                    @update:model-value="warehouse = $event"
                />
            </FormGroup>
        </div>
        <div class="card-footer d-flex justify-content-end">
            <AppButton
                size="sm"
                @click="create"
                color="teal"
                :disabled="!warehouse"
            >
                {{ $t('buttons.create') }}
            </AppButton>
        </div>
    </Card>
</template>

<script>
import Card from '../../../../components/new/CardComponent.vue'
import FormGroup from '../../../../components/new/form/group/FormGroup.vue'
import AppAutoComplete from '../../../../components/new/form/autocomplete/AppAutoComplete.vue'
import AppButton from '../../../../components/new/button/AppButton.vue'
import { httpClient } from '../../../../services/HttpClient'

export default {
    name: 'CreateInventoryPage',
    components: {
        Card,
        FormGroup,
        AppAutoComplete,
        AppButton
    },
    data() {
        return {
            warehouse: null
        }
    },
    methods: {
        create() {
            httpClient.post('/management/inventories', {
                warehouse_id: this.warehouse.id
            }).then((response) => {
                this.$router.push({ name: 'EditInventoryPage', params: { inventoryUuid: response.data.data.uuid } })
            })
        }
    }
}
</script>
